import { Method } from 'axios';

import { APICallV2Post, APICallV4 } from '../APICall';

export class ShareApiCall extends APICallV2Post {
    _method = 'folder/share';
}

export class ShareV4ApiCall extends APICallV4 {
    _method = 'folder/share';
    _type: Method = 'post';
}
